import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiCardOverrides = createComponentOverrides(function () { return ({
    defaultProps: {
        variant: 'outlined',
    },
}); });
